<template>
  <section class="vh-media-check-audioinput">
    <main>
      <!-- 选择音频输入设备(话筒) -->
      <section class="vh-media-check-selector">
        <label>{{ $t('host.k_535001') }}</label>
        <vh-select v-model="selectedId" v-if="devices.length != 0" @change="audioChange">
          <vh-option
            v-for="item in devices"
            :key="item.deviceId"
            :value="item.deviceId"
            :label="item.label"
          ></vh-option>
        </vh-select>
        <vh-select value="" v-if="devices.length == 0" disabled>
          <vh-option key="" value="" :label="$t('setting.setting_1033')"></vh-option>
        </vh-select>
      </section>

      <!-- 音量显示 -->
      <div class="vh-check-box microphone-preview">
        <preview-audio ref="previewAudio" :audioId="selectedId" />
      </div>
    </main>

    <footer class="vh-media-check-footer">
      <div class="vh-check-tip">
        <span class="vh-iconfont vh-line-microphone icon-tip"></span>
        <span>{{ $t('host.k_535002') }}</span>
      </div>
      <div class="button-container button-container__microphone">
        <vh-button round size="medium" class="confirm" type="primary" @click="success">
          {{ $t('host.k_535003') }}
        </vh-button>
        <vh-button round size="medium" plain type="info" class="cancel" @click="fail">
          {{ $t('host.k_535004') }}
        </vh-button>
      </div>
    </footer>
  </section>
</template>

<script>
  import PreviewAudio from '@/packages/volume-preview/src/main.vue';

  export default {
    name: 'choose-audio-input',
    props: {
      defaultSelected: {
        type: String,
        default: ''
      },
      devices: {
        type: Array,
        default: () => []
      }
    },
    components: {
      PreviewAudio
    },
    data() {
      return {
        selectedId: ''
      };
    },
    watch: {
      defaultSelected(cur) {
        this.setSelectedId(cur);
      }
    },
    mounted() {
      this.setSelectedId(this.defaultSelected);
    },
    methods: {
      setSelectedId(id) {
        this.selectedId = this.selectedId || id;
        this.audioChange();
      },
      async audioChange() {
        if (this.devices.length == 0) return;
        const mediaOptions = { audio: { deviceId: this.selectedAudioDeviceId } };
        const stream = await navigator.mediaDevices.getUserMedia(mediaOptions);
        stream.getTracks().forEach(trackInput => {
          console.log('[interactiveServer]  look stop -3');
          trackInput.stop();
        });
        this.$refs.previewAudio.initAudio(this.selectedId);
      },

      success() {
        window?.vhallReportForProduct?.report(110007, {
          report_extra: { dn: this.selectedId }
        }); // 埋点 - 麦克风设备检测成功

        this.$emit('next', { result: 'success', val: this.selectedId });
      },
      fail() {
        window?.vhallReportForProduct?.report(110011, {
          report_extra: { dn: this.selectedId }
        }); // 埋点 - 麦克风设备检测失败

        this.$emit('next', { result: 'fail' });
      }
    }
  };
</script>

<style lang="less">
  .vh-media-check-audioinput {
    width: 296px;
    margin: 0 auto;

    // selector
    .vh-media-check-selector {
      display: flex;
      align-items: center;

      label {
        flex: 0;
        min-width: 46px;
        font-size: 12px;
        color: #1a1a1a;
      }
      .vh-select {
        flex: 1;
      }
    }

    .vh-check-box {
      padding-top: 15px;
    }
    // footer
    .vh-media-check-footer {
      margin-top: 40px;
      margin-bottom: 30px;

      // tip
      .vh-check-tip {
        text-align: center;
        color: #1a1a1a;
        display: flex;
        justify-content: center;
        align-items: center;
        & > .vh-iconfont {
          font-size: 20px;
        }
        &.audio-preview {
          padding-top: 15px;
        }

        .icon-tip {
          color: #fb3a32;
          padding-right: 7px;
        }
      }

      // button-container
      .button-container {
        text-align: right;
        margin-top: 64px;
        position: absolute;
        bottom: 4px;
        right: 32px;

        .vh-button:last-child {
          margin-left: 12px;
        }
      }
    }
  }
</style>
